<template>
  <BaseSelect
    :id="id"
    :value="value"
    :resource="$data.$constants.RESOURCES.RESOURCE_JOBS"
    :http-body="parameters"
    :disabled="disabled"
    :label="label"
    :multiple="multiple"
    :reduce="reduce"
    @selected="$emit('option-selected', $event)"
    @input="$emit('input', $event)"
  />
</template>

<script>
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  name: 'JobsSelect',
  components: { BaseSelect },
  props: {
    value: {
      type: [Object, String, Number, Array],
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'name',
    },
    clientId: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    parameters: {
      type: Object,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    reduce: {
      type: Function,
      default: (item) => item,
    },
  },
  computed: {},
}
</script>